import {
  UPDATE_GAMESTATE,
  UPDATE_FEEDBACK,
  UPDATE_FEEDBACK_READ,
  SET_ROUND,
} from '../actions/types';

const emptyFeedback = {overigeEffecten:[]};

const initialState = {
  feedbackData: [],
  roundData: {},
  totalRounds: 0,
  currentRound: 1,
  prevRoundData: {},
  loaded: false,

  // Belasting feedback
  feedbackAB: emptyFeedback,
  feedbackBB: emptyFeedback,
  feedbackCB: emptyFeedback,
  feedbackVVB: emptyFeedback,
  feedbackVB: emptyFeedback,
  belastingFeedback: {},
  unreadCount: 0,
};
let feedbackData = [];

const feedbackReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch(type) {
    case UPDATE_GAMESTATE:

      break;
    case UPDATE_FEEDBACK:
      if(!feedbackData.length && !state.roundOverwritten) {
        state.currentRound = payload.length - 1;
      }
      feedbackData = payload;
      state.loaded = true;
      break;
    case UPDATE_FEEDBACK_READ:
      state.all.find((i) => {
        return i.feedback.find((fb) => {
          if (fb.id === payload.id) {
            return fb.read = payload.read;
          }
          return false;
        });
      });
      break;
    case SET_ROUND:
      state.currentRound = payload;
      state.roundOverwritten = (payload !== state.totalRounds - 1);
      break;
    default:
      return state;
  }
  state.all = feedbackData;
  state.prevRoundFeedbackData = !feedbackData.length?[]:feedbackData[state.currentRound-1].feedback;
  state.feedbackData = !feedbackData.length?[]:feedbackData[state.currentRound].feedback;
  state.roundData = !feedbackData.length?{}:feedbackData[state.currentRound].round;
  state.prevRoundData = feedbackData[state.currentRound-1].round;
  state.totalRounds = feedbackData.length;

  if (state.roundData.gameStateInput) {
    // Belasting feedback
    if (state.roundData.gameStateInput.niveau === "Basic") {
      state.belastingFeedback = state.feedbackData.find(fb => fb.type === 'BELASTING') || emptyFeedback;
      // const fbLaag = state.feedbackData.find(fb => fb.fileReference === 'BASIC_BELASTING_VERDIENDE_GLOBAS_0-60');
      // const fbMiddel = state.feedbackData.find(fb => fb.fileReference === 'BASIC_BELASTING_VERDIENDE_GLOBAS_61-80');
      // const fbHoog = state.feedbackData.find(fb => fb.fileReference === 'BASIC_BELASTING_VERDIENDE_GLOBAS_81');
    } else {
      state.feedbackAB = state.feedbackData.find(fb => fb.fileReference === 'PRO_BELASTING_OUTPUT_AB') || emptyFeedback;
      state.feedbackBB = state.feedbackData.find(fb => fb.fileReference === 'PRO_BELASTING_OUTPUT_BB') || emptyFeedback;
      state.feedbackCB = state.feedbackData.find(fb => fb.fileReference === 'PRO_BELASTING_OUTPUT_CB') || emptyFeedback;
      state.feedbackVVB = state.feedbackData.find(fb => fb.fileReference === 'PRO_BELASTING_OUTPUT_VVB') || emptyFeedback;
      state.feedbackVB = state.feedbackData.find(fb => fb.fileReference === 'PRO_BELASTING_OUTPUT_VB') || emptyFeedback;
    }
  }
  return {...state};
};

export default feedbackReducer;



// WEBPACK FOOTER //
// ./src/reducers/feedback.js